import {useCallback} from "react";
import {useAppSelector} from "../../../../../redux/hooks";
import {InputRefType, useInputRef} from "../../../../../components/common/hooks/useInputRef";
import {musicHomeStore} from "../../../../songs-router/modules/music-home-store/musicHomeStore";

export interface IMusicHomeSearchControlLogic {
  isMobileSearchActive: boolean,
  searchValue: string,
  searchInputRef: InputRefType;

  handleSearchInputFocus: () => void,
  handleSearchInputBlur: () => void,
  handleSearchInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void,
}

export const useMusicHomeSearchControlLogic = (): IMusicHomeSearchControlLogic => {
  const isMobileSearchMenuActive = useAppSelector(musicHomeStore.isMobileSearchActive);
  const doesSearchHaveValue = useAppSelector(musicHomeStore.doesMobileSearchHaveText);

  const isMobileSearchActive: boolean = (isMobileSearchMenuActive || doesSearchHaveValue);

  const searchValue = useAppSelector(musicHomeStore.getSearchText);

  const handleSearchInputChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    const {value} = event.currentTarget;
    musicHomeStore.setSearchFieldValue(value);
  }, []);

  const searchInputRef = useInputRef();

  return {
    isMobileSearchActive,
    searchValue,
    searchInputRef,
    handleSearchInputFocus: () => musicHomeStore.setSearchFieldFocus(true),
    handleSearchInputBlur: () => musicHomeStore.setSearchFieldFocus(false),
    handleSearchInputChange
  };
}
